<template>
    <div>
        <div>
            <el-table :data="$parentInfo.equipmentLeasing.cartShops"
                      style="width: 100%"
                      size="middle">
                <el-table-column prop="shop_name" label="商品名"></el-table-column>
                <el-table-column prop="amount" label="数量"> </el-table-column>
                <el-table-column prop="price" label="金额" ></el-table-column>
                <el-table-column prop="daily_rent" label="日租金" ></el-table-column>
                <el-table-column prop="return_day" label="归还日" ></el-table-column>
                <el-table-column prop="free_day" label="免租日" ></el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button icon="el-icon-delete" @click="handleDeleteCartShop(scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="text-align: center;padding-top: 10px">
            <el-button style="width: 150px" type="primary" @click="handleAddGood">添加商品</el-button>
        </div>
        <div>
            <el-checkbox v-model="$parentInfo.equipmentLeasing.checked" >试听租借</el-checkbox>
        </div>
        <div style="text-align: center">
            <el-button style="width: 150px" type="primary" @click="handleSettlement">结算</el-button>
        </div>
        <el-dialog
                :title="$parentInfo.equipmentLeasing.title"
                :visible.sync="$parentInfo.equipmentLeasing.dialogVisible"
                width="400px"
                height="700px"
                :before-close="handleClose"
                append-to-body>
            <Dialog_AddGood v-if="$parentInfo.equipmentLeasing.type=='addGood' && $parentInfo.equipmentLeasing.dialogVisible"></Dialog_AddGood>
        </el-dialog>
        <el-dialog
                :title="$parentInfo.equipmentLeasing.title"
                :visible.sync="$parentInfo.equipmentLeasing.settleDialogVisible"
                width="900px"
                height="700px"
                :before-close="handleClose"
                append-to-body>
            <Dialog_Settlement v-if="$parentInfo.equipmentLeasing.type=='settlement' && $parentInfo.equipmentLeasing.settleDialogVisible"></Dialog_Settlement>
        </el-dialog>
    </div>
</template>

<script>
    import Dialog_AddGood from './dialogs/Dialog_AddGood'
    import Dialog_Settlement from './dialogs/Dialog_Settlement'
    export default {
        name: "Index",
        data() {
            return {
            }
        },
        components: {
            'Dialog_AddGood': Dialog_AddGood,
            'Dialog_Settlement': Dialog_Settlement
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInit();
        },
        beforeDestroy(){
            this.$parentInfo.equipmentLeasing.cartShops=[];
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleInit(){

            },
            handleAddGood(){
                this.$parentInfo.equipmentLeasing.dialogVisible=true;
                this.$parentInfo.equipmentLeasing.type='addGood'
            },
            handleSettlement(){
                var sumPay=0;
                for (let j in this.$parentInfo.equipmentLeasing.cartShops) {
                    sumPay=sumPay+this.$parentInfo.equipmentLeasing.cartShops[j].price
                }
                this.$parentInfo.equipmentLeasing.dialog_settlement.sumPay=sumPay;

                this.$parentInfo.equipmentLeasing.settleDialogVisible=true;
                this.$parentInfo.equipmentLeasing.title='结算';
                this.$parentInfo.equipmentLeasing.type='settlement'
            },
            handleDeleteCartShop(index){
                this.$parentInfo.equipmentLeasing.cartShops.splice(index,1)
            },
            handleClose(done) {
                done();
            }
        }
    }
</script>

<style scoped>

</style>